import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const SkeletonWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 598px;
  background-color: var(--colorBlueGray1100);
  text-transform: none;
  position: relative;
  padding: 8px 16px 8px 16px;
  border-radius: 0px;
  border-bottom: 1px solid var(--colorBlueGray1000);
  animation: ${pulse} 2s ease-in-out infinite;
`;

const ImageSkeleton = styled.div`
  width: 128px;
  height: 80px;
  border-radius: 8px;
  background-color: var(--colorBlueGray1000);
  flex-shrink: 0;
`;

const TextBlockSkeleton = styled.div<{ fontSize: string }>`
  font-size: ${(props) => props.fontSize || '14px'};
  border-radius: 4px;
  background-color: var(--colorBlueGray1000);
  margin-bottom: 4px;
  color: transparent;
  height: ${(props) => props.fontSize || '14px'};
`;

/** Compact loading skeleton for Feature component in non-fullInfo mode */
const CompactFeatureSkeleton: FC = () => {
  const isSmallWidthTablet = window.innerWidth > 944 && window.innerWidth < 1168;

  return (
    <SkeletonWrapper>
      <Box display="flex" gap="small" flexDirection="row" alignItems="flex-start">
        {!isSmallWidthTablet && <ImageSkeleton />}

        {/* The following text to make sure the loading skeleton takes up full width */}
        <Box display="flex" flexDirection="column" alignItems="flex-start" gap="xs">
          <TextBlockSkeleton fontSize="12px">---------------</TextBlockSkeleton>
          <TextBlockSkeleton fontSize="16px">-----------------------</TextBlockSkeleton>
          <TextBlockSkeleton fontSize="14px">
            {isSmallWidthTablet
              ? '----------------------------------------------'
              : '-----------------------------------------------------------------------------'}
          </TextBlockSkeleton>
        </Box>
      </Box>
    </SkeletonWrapper>
  );
};

export default CompactFeatureSkeleton;
